/**
 * Drives .carousel-progress-bar elements: finds the nearest horizontal
 * carousel scroller (slideshow-slides) within the same section and keeps
 * the bar's fill width and aria-valuenow in sync with scroll position.
 */

function findScroller(bar) {
  const scope = bar.closest('.shopify-section') || bar.closest('.section') || document;
  return scope.querySelector('slideshow-slides');
}

function bind(bar) {
  if (bar.dataset.progressBound === 'true') return;

  const scroller = findScroller(bar);
  if (!scroller) return;

  const fill = bar.querySelector('.carousel-progress-bar__fill');
  if (!fill) return;

  const update = () => {
    const max = scroller.scrollWidth - scroller.clientWidth;
    const percent = max > 0 ? (scroller.scrollLeft / max) * 100 : 0;
    const clamped = Math.min(100, Math.max(0, percent));

    fill.style.width = `${clamped}%`;
    bar.setAttribute('aria-valuenow', `${Math.round(clamped)}`);
  };

  scroller.addEventListener('scroll', update, { passive: true });

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(update).observe(scroller);
  }

  update();
  bar.dataset.progressBound = 'true';
}

function init() {
  document.querySelectorAll('.carousel-progress-bar').forEach(bind);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
